import { render, staticRenderFns } from "./LabelLaudoSituacao.vue?vue&type=template&id=66957862&scoped=true&lang=pug"
import script from "./LabelLaudoSituacao.vue?vue&type=script&lang=js"
export * from "./LabelLaudoSituacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66957862",
  null
  
)

export default component.exports